import React, { useState } from "react";
import styled from "styled-components";
import UploadOneImgCarre from "../../../Utils/UploadOneImgCarre";
import PreviewImgCarre from "../../../Utils/PreviewImgCarre";
import { COLORS } from "../../../../COLORS";
import BtnLoader from "../../../Utils/BtnLoader";
import { toast } from "react-toastify";
import axios from "axios";

const FormBusinessFree = () => {
  const [imgPreviewUrl, setImgPreviewUrl] = useState<string>("");
  const [imgToUpload, setImgToUpload] = useState<File[] | null>([]);
  const [urlRedirection, setUrlRedirection] = useState("");
  const [business, setBusiness] = useState("");
  const [info, setInfo] = useState("");
  const [sending, setSending] = useState(false);
  const pullUpImg = () => {
    setImgPreviewUrl("");
    setUrlRedirection("");
    setBusiness("");
    setImgToUpload([]);
    setInfo("");
  };

  const sendImagePub = async () => {
    if (!imgPreviewUrl || !urlRedirection || !business) {
      return toast.error("Tous les champs sont obligatoires");
    }
    if (!urlRedirection.startsWith("https://")) {
      return toast.error(
        "Veuillez entrer un lien valide commençant par https://"
      );
    }
    setSending(true);
    const data = new FormData();
    data.append("linkRedirectionCarre", urlRedirection);
    data.append("business", business);
    if (imgToUpload && imgToUpload.length > 0) {
      data.append("fileCarre", imgToUpload[0]);
    }

    try {
      const res = await axios({
        method: "post",
        url: `${process.env.REACT_APP_API}partenaire/campagne/create`,
        withCredentials: true,
        data,
      });
      if (res.data.message) {
        setSending(false);
        pullUpImg();
        return toast.success(res.data.message);
      }
    } catch (error: any) {
      console.log(error);
      return toast.error(error.response.data.error);
    }
  };
  return (
    <StyledFormBusinessFree>
      <span>
        Charger votre image publicitaire. Elle sera dans la rubrique /Business*
      </span>
      <input
        type="text"
        placeholder="Nom entreprise"
        className="business"
        defaultValue={business ? business : ""}
        onChange={(e) => setBusiness(e.target.value)}
      />
      <label htmlFor="linkRedirection">
        Vers où l'utilisateur sera redirigé ? (Instagram ,site web, whatsapp)
      </label>
      <input
        type="url"
        id="linkRedirection"
        defaultValue={urlRedirection ? urlRedirection : ""}
        onChange={(e) => setUrlRedirection(e.target.value)}
        placeholder="Lien de redirection"
      />
      <strong>{info}</strong>
      <UploadOneImgCarre
        setImgPreviewUrl={setImgPreviewUrl}
        setImgToUpload={setImgToUpload}
        setInfo={setInfo}
      />
      {imgPreviewUrl && urlRedirection && !sending && (
        <button
          className="animate__animated animate__bounceIn"
          onClick={() => sendImagePub()}
        >
          Envoyer
        </button>
      )}
      {sending && <BtnLoader />}
      {imgPreviewUrl && (
        <PreviewImgCarre imgPreviewUrl={imgPreviewUrl} pullUpImg={pullUpImg} />
      )}
      <span className="lil">
        *Seules les entreprises basées en Guyane française sont acceptées. Si ce
        n’est pas le cas ou en cas de doute, l’annonce sera supprimée. Les
        informations saisies ne seront pas enregistrées. En soumettant votre pub
        vous acceptez nos CGU.
      </span>
    </StyledFormBusinessFree>
  );
};

export default FormBusinessFree;
const StyledFormBusinessFree = styled.div`
  display: flex;
  width: 50%;
  margin: 10px auto;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  span {
    font-size: 1.2em !important;
  }
  .business {
    margin-top: 20px;
  }
  label {
    margin-top: 10px;
    margin-bottom: 5px;
    width: 50%;
    color: ${COLORS.border_and_text_blue};
  }
  input {
    width: 50%;
    padding: 3px 7px;
    border-radius: 3px;
    font-size: 1.1em;
    border: solid 2px ${COLORS.border_and_text_blue};
    background: ${COLORS.main};
    color: ${COLORS.border_and_text_blue};
    outline: none;
    &::placeholder {
      color: #ffffffc4;
    }
  }
  strong {
    margin-top: 10px;
    color: ${COLORS.danger};
  }
  button {
    font-size: 1.5em;
    padding: 5px 20px;
    border-radius: 10px;
    color: ${COLORS.border_and_text_blue};
    cursor: pointer;
    border: solid 2px ${COLORS.border_and_text_blue};
    background: ${COLORS.main};
  }
  .lil {
    margin-top: 40px;
    color: ${COLORS.orange_new} !important;
    font-size: 0.8em !important;
  }
  @media screen and (max-width: 445px) {
    width: 100%;
    span {
      font-size: 1em !important;
    }
    label,
    input {
      width: 100%;
    }
  }
`;
